import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Tippy from '@tippyjs/react';

// eslint-disable-next-line import/no-extraneous-dependencies
import 'tippy.js/themes/light.css';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'tippy.js/dist/tippy.css';
import { useTheme } from 'styled-components';
import { GlobalTooltipStyle } from './styles';
const mapPlacement = placement => ({
  rightTop: 'right-start',
  rightBottom: 'right-end',
  leftBottom: 'left-end',
  leftTop: 'left-start',
  topLeft: 'top-start',
  topRight: 'top-end',
  bottomLeft: 'bottom-start',
  bottomRight: 'bottom-end'
})[placement] || placement;
const BaseTooltip = /*#__PURE__*/forwardRef(({
  children,
  popup,
  placement = 'top',
  background = 'dark',
  trigger: triggerArr = ['mouseenter', 'focus'],
  arrow = true,
  maxWidth = 350,
  appendTo = 'parent',
  visible,
  onClickOutside = () => {},
  ...tippyProps
}, ref) => {
  const isControlled = visible !== undefined;
  const trigger = isControlled ? undefined : triggerArr?.join?.(' ');
  const theme = useTheme();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tippy, _extends({
    onCreate: instance => {
      if (!ref) return;
      // eslint-disable-next-line no-param-reassign
      ref.current = instance;
    },
    content: popup,
    placement: mapPlacement(placement),
    interactive: true,
    theme: background,
    appendTo: appendTo === 'body' ? document.body : appendTo,
    zIndex: theme.zIndex.tooltip,
    arrow,
    trigger,
    maxWidth,
    visible,
    onClickOutside
  }, tippyProps), children), /*#__PURE__*/React.createElement(GlobalTooltipStyle, null));
});
BaseTooltip.propTypes = {
  children: PropTypes.node.isRequired,
  popup: PropTypes.node.isRequired,
  placement: PropTypes.oneOf(['top', 'bottom', 'right', 'left', 'rightTop', 'rightBottom', 'leftBottom', 'leftTop', 'topLeft', 'topRight', 'bottomLeft', 'bottomRight']),
  background: PropTypes.oneOf(['light', 'dark']),
  trigger: PropTypes.arrayOf(PropTypes.string),
  arrow: PropTypes.bool,
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  appendTo: PropTypes.oneOf(['body', 'parent'])
};
export default BaseTooltip;
//# sourceMappingURL=BaseTooltip.js.map